import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const DatasetKey = iotsUtils.fromList(constants.report.usageReports.datasetKeys);
